import {
  GET_EMAIL_EVENTS,
  GET_EMAIL_EVENTS_SUCCESS,
  GET_EMAIL_EVENTS_ERROR,
  CREATE_EMAIL,
  CREATE_EMAIL_ERROR,
  CREATE_EMAIL_SUCCESS,
  UPDATE_CURRENT_EMAIL,
  RESET_EMAIL_ERROR,
  UPDATE_EMAIL,
  UPDATE_EMAIL_SUCCESS,
  UPDATE_EMAIL_ERROR,
  GET_EMAIL_TEMPLATE_BY_ID,
  GET_EMAIL_TEMPLATE_BY_ID_SUCCESS,
  GET_EMAIL_TEMPLATE_BY_ID_ERROR,
  RESET_EMAIL_TEMPLATE_BY_ID,
  CHECK_EMAIL_STATUS_BY_EVENT,
  CHECK_EMAIL_STATUS_BY_EVENT_SUCCESS,
  CHECK_EMAIL_STATUS_BY_EVENT_ERROR,
  DELETE_EMAIL_STATUS_BY_EVENT,
  DELETE_EMAIL_STATUS_BY_EVENT_SUCCESS,
  DELETE_EMAIL_STATUS_BY_EVENT_ERROR
} from "./actionTypes"

export const getEmailEvents = (query_params, paginated) => {
  return {
    type: GET_EMAIL_EVENTS,
    payload: query_params,
    paginated: paginated
  }
}

export const getEmailEventsSuccess = (email, meta) => ({
  type: GET_EMAIL_EVENTS_SUCCESS,
  payload: email,
  meta,
})

export const getEmailEventsError = (error) => ({
  type: GET_EMAIL_EVENTS_ERROR,
  payload: error
})

export const createEmail = (payload) => ({
  type: CREATE_EMAIL,
  payload: payload
})

export const createEmailSuccess = (email) => ({
  type: CREATE_EMAIL_SUCCESS,
  payload: email
})

export const createEmailError = (error) => ({
  type: CREATE_EMAIL_ERROR,
  payload: error
})

export const updateCurrentEmail = (email) => ({
  type: UPDATE_CURRENT_EMAIL,
  payload: email
})

export const updateEmail = (email) => ({
  type: UPDATE_EMAIL,
  payload: email
})

export const updateEmailSuccess = (email) => ({
  type: UPDATE_EMAIL_SUCCESS,
  payload: email
})

export const updateEmailError = (email) => ({
  type: UPDATE_EMAIL_ERROR,
  payload: email
})

export const resetEmailError = () => ({
  type: RESET_EMAIL_ERROR
})


// For GET_EMAIL_TEMPLATE_BY_ID

export const getEmailTemplateById = (event) => ({
  type: GET_EMAIL_TEMPLATE_BY_ID,
  payload: event
})

export const getEmailTemplateByIdSuccess = (event) => ({
  type: GET_EMAIL_TEMPLATE_BY_ID_SUCCESS,
  payload: event
})

export const getEmailTemplateByIdError = (error) => ({
  type: GET_EMAIL_TEMPLATE_BY_ID_ERROR,
  payload: error
})

export const checkEmailStatuByEvent = (event) => ({
  type: CHECK_EMAIL_STATUS_BY_EVENT,
  payload: event
})

export const checkEmailStatuByEventSuccess = (event) => ({
  type: CHECK_EMAIL_STATUS_BY_EVENT_SUCCESS,
  payload: event
})

export const checkEmailStatuByEventError = (error) => ({
  type: CHECK_EMAIL_STATUS_BY_EVENT_ERROR,
  payload: error
})

export const deleteEmailStatusByEvent = (event) => ({
  type: DELETE_EMAIL_STATUS_BY_EVENT,
  payload: event
})

export const deleteEmailStatusByEventSuccess = (event) => ({
  type: DELETE_EMAIL_STATUS_BY_EVENT_SUCCESS,
  payload: event
})

export const deleteEmailStatusByEventError = (error) => ({
  type: DELETE_EMAIL_STATUS_BY_EVENT_ERROR,
  payload: error
})


export const resetEmailTemplateById = () => ({
  type: RESET_EMAIL_TEMPLATE_BY_ID
})
